import React from 'react';
import MultiCategoryDisplay from '../layout/MainBestilLayout/MultiCategoryDisplay';
import { LinkStyled, Paragraph } from '../../../components/typography';
import { Price } from '../../../containers/commerce';

export default () => (
  <React.Fragment>
    <Paragraph>
      Sendes med Post Nord, pris: <Price varenr="620" momsIndication />. Fremme indenfor 3 hverdage eller hent selv gratis.
    </Paragraph>
    <MultiCategoryDisplay page="FadoelOgAnlaeg" subPage="Reservedele" />
    <Paragraph marginTop="10px">
      <LinkStyled external to="/pdf/datahaefte-reservedele.pdf">Datahæfte for reservedele</LinkStyled>
    </Paragraph>
  </React.Fragment>
);
